import { UiButtonProps, UiButton } from '@open-stack/ui';
import React from 'react';
import './XButton.scss';
import clsx from 'clsx';

export interface XButtonProps extends UiButtonProps {
    cta?: boolean;
}

export function XButton({ className, cta, ...rest }: XButtonProps) {
    return <UiButton className={clsx(className, '_XButton', { cta })} {...rest} />;
}
